import { Reveal } from "../Reveal";
import { Badge } from "../Pill";

export default function Testimonials({ items }) {
  return (
    <section data-testid="testimonials-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center"><Badge tone="petal">Voices of Distinction</Badge></Reveal>
        <Reveal delay={0.1} className="text-center">
          <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl text-ink leading-[0.98]">
            Loved by the industry<br className="hidden md:block" /> we chronicle
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {(items || []).map((t, i) => (
            <Reveal key={i} delay={0.08 * i}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full bg-blush rounded-[2rem] p-8 md:p-10 flex flex-col transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(232,165,184,0.35)]"
              >
                <span className="font-elegant italic text-6xl leading-none text-rose select-none" aria-hidden="true">&ldquo;</span>
                <blockquote className="mt-4 text-sm md:text-base leading-relaxed text-neutral-700 flex-1">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-8 flex items-center justify-between gap-4">
                  <div>
                    <p className="font-display uppercase text-lg text-ink">{t.name}</p>
                    <div className="mt-2"><Badge tone="white">{t.role}</Badge></div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
